'use client'

import { useDispatch, useSelector } from 'react-redux'
import { loginUser, logoutUser } from '@/shared/store/slice/authSlice.js'
import { useCheckUserMutation, useLogoutMutation } from '../api-rtk'
import { useEffect } from 'react'

export const useGetIsAuthUser = () => {
    const [checkUser] = useCheckUserMutation()
    const [apiLoguot] = useLogoutMutation()
    const dispatch = useDispatch()
    const userAuth = useSelector((state) => state.authUser.isAuth)
    const userInfo = useSelector((state) => state.authUser.userInfo)

    return {
        userAuth,
        userInfo,
        setUser: (data) => dispatch(loginUser(data)),
        logoutUser: async () => {
            await apiLoguot()
            dispatch(logoutUser())
        },
    }
}
